import ReactInputMask from "react-input-mask";
import styled from "styled-components";

export const ScrollList = styled.div`
  width: 270px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-radius: 5px;
  padding-left: 12px;
  background-color: #f1f1f1;
  border: 1px solid #0000001c;
  height: calc(100% - 30px);

  ul {
    margin: 0 !important;
    overflow: scroll;
    height: 100%;

    ::-webkit-scrollbar {
      width: 12px; /* Largura da scrollbar */
      background-color: #f1f1f1; /* Cor de fundo da scrollbar */
      height: 100%;
    }

    /* Estilo da parte interna (thumb) que se move */
    ::-webkit-scrollbar-thumb {
      background-color: #888; /* Cor da thumb */
      border-radius: 10px; /* Arredondamento */
      border: 2px solid #f1f1f1; /* Borda ao redor da thumb */
    }

    /* Estilo da scrollbar ao passar o mouse */
    ::-webkit-scrollbar-thumb:hover {
      background-color: #555; /* Cor da thumb ao hover */
    }

    /* Opcional: Estilo dos cantos */
    ::-webkit-scrollbar-corner {
      background-color: #f1f1f1; /* Cor do canto da scrollbar */
    }
  }
`;

export const Container = styled.div`
  padding: 0px 15px 0 15px;
  min-width: 300px;
  opacity: ${(props) => (props.done ? 0.6 : 1)};

  & + div {
    border-left: 1px solid rgba(0, 0, 0, 0.05);
  }

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 45px;
    min-width: 280px;
    margin-left: -10px;
    padding-left: 10px;
    background-color: #fff;
    padding-bottom: 10px;

    h2 {
      font-weight: 600;
      font-size: 15px;
      padding: 0 10px;
    }

    button {
      width: 30px;
      height: 30px;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0px;
    }
  }

  ul {
    margin-top: 30px;
  }
`;

export const InputTel = styled(ReactInputMask)`
  box-sizing: border-box;
  margin: 0;
  padding: 4px 11px;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
  line-height: 1.5714285714285714;
  list-style: none;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  background-color: #ffffff;
  background-image: none;
  border-width: 1px;
  border-style: solid;
  border-color: #d9d9d9;
  border-radius: 6px;
  transition: all 0.2s;
  ::placeholder {
    color: #bbb;
    font-size: 13px;
  }
`;

export const ViewInput = styled.div`
  min-height: 40px;
  border-radius: 5px;
  width: 100%;
  max-width: 420px;
  margin-bottom: 5px;
  justify-content: space-between;
  text-align: center;

  p {
    width: 100%;
    font-size: 12px !important;
    text-align: left;
    margin: 0 0 2px 5px;
  }
`;

export const ModalConfirm = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  align-items: center;
  z-index: 99999;
  justify-content: center;
  display: ${(props) => (props.open ? "flex" : "none")};
  transition: 0.5s;
  .content {
    width: 350px;
    background: #fff;
    border-radius: 7px;
    display: flex;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    padding: 15px;
    z-index: 1000;
    display: ${(props) => (props.open ? "block" : "none")};
    transition: 0.5s;
    &-header {
      display: flex;
      margin-bottom: 20px;
      position: relative;

      p {
        width: calc(100% - 60px);
        text-align: left;
      }

      .close-button {
        position: absolute;
        top: 0px;
        right: 0px;
        display: flex;
        background: transparent;
        align-items: center;
        justify-content: center;
      }
    }
    &-main {
      padding: 20px 0 40px 0;
      text-align: center;
      > div {
        padding: 5px;
        > span {
          display: block;
        }
      }
    }
    &-footer {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        color: #6a6a6a;
        font-size: 14px;
        cursor: pointer;
      }
      button {
        border: none;
        padding: 10px 15px;
        border-radius: 5px;
        position: relative;
        text-transform: none;
        transition: all 0.15s ease;
        letter-spacing: 0.025em;
        font-size: 0.875rem;
        color: #fff;
        background-color: #f2760a;
        box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11),
          0 1px 3px rgba(0, 0, 0, 0.08);
      }
    }
  }
`;
